<template>
  <div>
    <Headline
      :title="title"
      subtitle="Concéntrese en el objetivo de su viaje.<br>¡Le aseguramos el éxito!"
      image="corporate"
      variant="dark"
    ></Headline>
    <Section image="corporate-1">
      <Card
        title="MEJOR PRECIO GARANTIZADO"
      >Si lo encuentra más barato le garantizamos el mejor precio.</Card>
      <Card
        title="ALTERNATIVAS PARA SUS VIAJES"
      >Tres alternativas de vuelo y hotel, de la más conveniente a la más económica, con seguimiento del ahorro perdido.</Card>
      <Card
        title="APLICACIÓN MÓVIL GEOTUR"
      >Su itinerario de viaje, notificaciones de retrasos de vuelos, facturación, tarjeta de embarque, gestión de preferencias... todo en la palma de su mano.</Card>
    </Section>
    <Section image="corporate-2">
      <Card
        title="Soluciones completas"
        image="corporate-1"
        size="lg"
      >Viajes de negocios o placer, eventos, reuniones, viajes de incentivo y congresos.</Card>
    </Section>
    <Section image="corporate-3">
      <Card
        title="Integración con los sistemas de su empresa"
        size="lg"
      >Reservas en línea con inicio de sesión único y sincronización de los datos de los pasajeros, creación automática de pedidos de compra en su ERP, factura electrónica y acceso a informes en línea.</Card>
      <Card
        title="Representante exclusivo One Global Travel para España y Portugal"
        size="lg"
      ><a href="https://oneglobaltravel.com/">OneGlobalTravel.com</a></Card>
    </Section>
    <Section image="corporate-4">
      <Card
        image="corporate-2"
        to="/contactos"
        button-label="Viaja con nosotros"
      >Nuestro equipo 24H le asegura una asistencia personalizada en su desplazamiento. Póngase en contacto con nosotros por teléfono, WhatsApp o Skype.</Card>
      <Card
        image="corporate-3"
        to="/contactos"
        button-label="Viaja con nosotros"
      >Relájese en el Lounge del aeropuerto - se lo merece! Adquiera un Geotur Priority Pass y acceda a los Lounges de los principales aeropuertos del mundo, incluso cuando viaje en clase económica.</Card>
    </Section>
  </div>
</template>
<script setup>
definePageMeta({
  title: 'Viajes corporativos',
  path: '/servicios/viajes-corporativos',
})
const title = useRoute().meta.title
useHead({
  title: `${title} | Geotur`,
})
</script>